<template>
  <vs-popup title="Distribute Courses" :active.sync="show">
    <div class="flex items-start justify-between mb-2">
      <div>
        <div class="flex items-center mb-2">
          <h5 class="mr-2">To</h5>
          <div class="custom-dropdown" v-if="checkAdmin">
            <div class="flex flex-wrap selected-segments items-center">
              <vs-chip
                v-for="(item, idx) in selectedSegments"
                :key="idx"
                class="mx-1"
                closable
                @click="removeSegment(item)"
              >{{ item }}
              </vs-chip>
            </div>
            <div class="dropdown-content">
<!--              <template v-if="userSegments.length > 0">-->
              <template >
                <div v-for="(segment, idx) in userSegments" :key="idx">
                  <h5 class="group-item-label">{{ segment.label }}</h5>
                  <ul class="group-options">
                    <template v-for="(option, idx) in segment.options">
                      <li @click.stop :key="idx">
                        <vs-checkbox style="width: 380px; z-index: 20"
                          color="danger"
                          v-model="selectedSegments"
                          :vs-value="option"
                        >
                          {{ option }}</vs-checkbox
                        >
                      </li>
                    </template>
                  </ul>
                </div>
              </template>
            </div>
          </div>
          <div class="custom-dropdown" v-else>
            <div class="flex flex-wrap selected-segments items-center">
              <vs-chip
                v-for="(item, idx) in selectedSegments"
                :key="idx"
                class="mx-1"
                closable
                @click="removeSegment(item)"
              >{{ item }}
              </vs-chip>
            </div>
            <div class="dropdown-content">
              <!--              <template v-if="userSegments.length > 0">-->


              <template >
                <div v-for="(segment, idx) in alexUserData.data" :key="idx">
                   <ul class="group-options">
                    <template>
                      <li @click.stop :key="idx">
                        <vs-checkbox
                          color="danger"
                          v-model="selectedSegments"
                          :vs-value="segment.userData.email"
                        >
                          {{ segment.userData.email}}</vs-checkbox
                        >
                      </li>
                    </template>
                  </ul>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <vs-button
        type="filled"
        color="danger"
        @click="sendEmail"
        :disabled="!selectedSegments.length > 0"
        >Send</vs-button
      >
    </div>
    <vs-textarea
      class="w-full"
      placeholder="Add Remarks..."
      v-model="remarks"
    />
    <template v-for="(trainingItem, idx) in courseList">
      <LibraryItemCard
        :item="trainingItem"
        :key="idx"
        class="mb-2"
        layout="landscape"
      />
    </template>
  </vs-popup>
</template>
<script>
  import {
    successNotifyService,
  } from "@/services/errors.service.js";
import LibraryItemCard from "./LibraryItemCard";
// import { userSegments } from "@/assets/data/alex";
export default {
  name: "DistributeCoursesModal",
  components: {
    LibraryItemCard,
  },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    courseList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedSegments: [],
      alexUserData: [],
      departmentUserIdData:[],
      roleTitleUserIdData:null,
      organizationIdBySlug:"",
      remarks: "",
      checkAdmin:false
    };
  },
  computed: {
    show: {
      get() {
        return this.active;
      },
      set(val) {
        this.$emit("update:active", val);
      },
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    userSegments() {
      return this.$store.state.alex.userSegments;
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
  },
  methods: {
    removeSegment(val) {
      this.selectedSegments.splice(this.selectedSegments.indexOf(val), 1);
    },
    async sendEmail(){

      if(this.checkAdmin) {
         let department=[];
         let level=[];
         let roleTitle=[];
         let identifiedGaps=[];
         const userIDs =[];

         // console.log('Level',this.userSegments[0].options);
         // console.log('Function',this.userSegments[1].options);
         // console.log('Department',this.userSegments[2].options);
         // console.log('IdentifiedGap',this.userSegments[3].options);
        for(let i=0;i<this.selectedSegments.length;i++) {
          // Alex User Segments Array For Level
          if (this.userSegments[0].options.length > 0) {
            for (let j = 0; j < this.userSegments[0].options.length; j++) {
              if (this.selectedSegments[i] === this.userSegments[0].options[j]) {
                level.push(this.selectedSegments[i]);
              }
            }
          }
        }
        for(let i=0;i<this.selectedSegments.length;i++) {
          // Alex User Segments Array For Function
          if (this.userSegments[1].options.length > 0) {
            for (let j = 0; j < this.userSegments[1].options.length; j++) {
              if (this.selectedSegments[i] === this.userSegments[1].options[j]) {
                department.push(this.selectedSegments[i]);
              }
            }
          }
        }
        for(let i=0;i<this.selectedSegments.length;i++) { // Alex User Segments Array For roleTitle
          if(this.userSegments[2].options.length>0) {
            for (let j = 0; j < this.userSegments[2].options.length; j++) {
              if (this.selectedSegments[i] === this.userSegments[2].options[j]) {
                roleTitle.push(this.selectedSegments[i]);
              }
            }
          }
          }
        for(let i=0;i<this.selectedSegments.length;i++) {
          //Alex  User Segments Array For identifiedGaps
           if(this.userSegments[3].options.length>0){
            for(let j=0;j<this.userSegments[3].options.length;j++) {
              if(this.selectedSegments[i]===this.userSegments[3].options[j]) {
                identifiedGaps.push(this.selectedSegments[i]);
              }
            }
          }
        }
        // // console.log('Level',level);
        // // console.log('Function',department);
        // // console.log('Department',roleTitle);
        // // console.log('IdentifiedGap',identifiedGaps);
        if(department.length>0){
            let query3 ={
            "department":'IT',
             "organizationId":this.organizationIdBySlug
             }
          await   this.$store
          .dispatch("alex/fetcDepartmenByAlexUser", query3)
          .then((res) => {
            if(res.data.length>0) {
              for(let i=0;i<res.data.length;i++){
                userIDs.push(res.data[i].userId);
             }
          }}
          );
        } if(roleTitle.length>0){
            let query3 ={
            "department":roleTitle,
             "organizationId":this.organizationIdBySlug
             }
          await this.$store
          .dispatch("alex/fetchroleTitleByAlexUser", query3)
          .then((res) => {
            if(res.data.length>0) {
              for(let i=0;i<res.data.length;i++){
                userIDs.push(res.data[i].userId);
                }
          }}
          );
        }
        if(level.length>0){
          let query3 ={
            "department":level,
            "organizationId":this.organizationIdBySlug
          }
          await this.$store
            .dispatch("alex/fetchLevelByAlexUser", query3)
            .then((res) => {

              if(res.data.length>0) {
                for(let i=0;i<res.data.length;i++){
                  userIDs.push(res.data[i].userId);
                 }
              }}
            );
        }
        if(identifiedGaps.length>0){
          let query3 ={
            "department":identifiedGaps,
            "organizationId":this.organizationIdBySlug
          }
          await this.$store
            .dispatch("alex/fetchIdentifiedGapsByAlexUser", query3)
            .then((res) => {
              if(res.data.length>0) {
                for(let i=0;i<res.data.length;i++){
                  userIDs.push(res.data[i].userId);
                }
              }}
            );
        }
        let uniqueUserId=[...new Set(userIDs)]
        // console.log('allUserId',uniqueUserId);
        let emailData =[];
        for(let k=0;k<uniqueUserId.length;k++) {
          // await this.$store
          //   .dispatch("users/fetchUser", uniqueUserId[k])
          //   .then((alexUser) => {
          //     this.$store
          //       .dispatch("alex/fetchDetails", this.userId)
          //       .then(res => {
          //         // console.log('res',res.data._id);
          //         let distributeEmailData = {
          //           "_id": res.data._id,
          //           "remarks": this.remarks,
          //           "courseList": this.courseList,
          //           "firstName":alexUser.data.firstName,
          //           "lastName":alexUser.data.lastName,
          //           "email": alexUser.data.email,
          //           "MailFrom":"hrAdmin",
          //           "flag": "distributeCourse"
          //         }
          //         // console.log(distributeEmailData);
          //         this.$store
          //           .dispatch("alex/updateAlex", distributeEmailData)
          //           .then(res => {
          //                 this.show=false;
          //             this.remarks='';
          //             this.courseList=[];
          //             this.selectedSegments=[];
          //
          //           })
          //           .catch((err) => {
          //             throw err;
          //           })
          //       })
          //       .catch((err) => {
          //         throw err;
          //       })
          //   })
          //   .catch((err) => {
          //     throw err;
          //   });
        }
        const payload = {
          title: "Email Sent",
          text: `Email Sent SuccessFully from Hr Side.`,
          currentThis: this,
        };
        successNotifyService(payload);
      }
      else{

        // console.log(this.selectedSegments);
        // console.log(this.remarks);
        // console.log(this.courseList);

          // this.$store
          //   .dispatch("alex/fetchDetails", this.userId)
          //   .then(res => {
          //     let distributeEmailData = {
          //       "_id": res.data._id,
          //       "remarks": this.remarks,
          //       "courseList": this.courseList,
          //       "MailFrom":"user",
          //       "email": this.selectedSegments,
          //       "flag": "distributeCourse"
          //     }
          //     // console.log(distributeEmailData);
          //     this.$store
          //       .dispatch("alex/updateAlex", distributeEmailData)
          //       .then(res => {
          //         this.show=false;
          //         this.remarks='';
          //         this.courseList=[];
          //         this.selectedSegments=[];
          //         const payload = {
          //           title: "Email Sent",
          //           text: `Email Sent SuccessFully from Hr Side.`,
          //           currentThis: this,
          //         };
          //         successNotifyService(payload);
          //       })
          //       .catch((err) => {
          //         throw err;
          //       })
          //   })
          //   .catch((err) => {
          //     throw err;
          //   })
                 const payload = {
                    title: "Email Sent",
                    text: `Couse Distributed .`,
                    currentThis: this,
                  };
                  successNotifyService(payload);
      }
    }
  },
  created (){
    const organizationSlug = this.$route.params.organizationSlug;
    if (organizationSlug) {
      this.$store
        .dispatch("organization/fetchOrganizationBySlug", organizationSlug)
        .then((org) => {
          if (!org.data.data[0].activeMarketplace) this.$router.push("/");
          else {
            this.organizationIdBySlug= org.data.data[0]._id;
            this.$store
              .dispatch("organization/checkAlexAdminByEmail", {
                email: this.$store.state.auth.user.email
              })
              .then((res) => {
                // console.log(org.data.data[0].userId,this.$store.state.auth.user._id)
                if (JSON.stringify(org.data.data[0].userId) === JSON.stringify(this.$store.state.auth.user._id)) {
                  this.checkAdmin = true;
                  // console.log('Super Admin Check');
                }else{
                // console.log('Sub admin 1 ,User 0 :response',res.data.length);
                if (res.data.length!== 0){
                  // console.log('true');
                  this.checkAdmin = true;
                  // console.log('Sub Admin Check');
                } else {
                  // console.log('true');
                  this.$store.dispatch("alex/fetchAlexUser",org.data.data[0]._id).then(res=>{
                    this.alexUserData=res;
                  });
                  this.checkAdmin = false;
                  // console.log('User Check');
                }
              }
              })
          }
        })
        .catch((err) => {
          throw err;
        });
    }

  }
};
</script>
<style scoped>
.custom-dropdown {
  position: relative;
  display: inline-block;
}
.dropdown-content {
  position: absolute;
  display: none;
  min-width: 420px;
  max-height: 200px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0px 0px 5px 5px;
  padding: 12px 16px;
  overflow: auto;
  background: #fff;
  z-index: 1;
}
.selected-segments {
  width: 420px;
  border: 1px solid #d4d2d2;
  min-height: 40px;
  border-radius: 5px;
  padding: 5px;
}

.custom-dropdown:hover .dropdown-content {
  display: block;
}

.group-item-label {
  padding: 2px;
  color: #231d4f;
  font-weight: 500;
  font-size: 1rem;
  text-align: left;
}
.group-options li {
  padding: 0.5rem 0;
  color: #848199;
}
</style>
